// Shared permissions helper — single source of truth for page access

export const ROLE_DEFAULTS = {
  admin: [
    'Dashboard', 'Vehicles', 'Drivers', 'Routes', 'Students',
    'Trips', 'Return Trips Map', 'Notifications', 'Users',
    'Reports - Parents', 'Reports - Trip Report', 'Reports - Student Report',
  ],
  operator: [
    'Dashboard', 'Vehicles', 'Drivers', 'Routes', 'Students',
    'Trips', 'Return Trips Map',
    'Reports - Parents', 'Reports - Trip Report', 'Reports - Student Report',
  ],
};

/**
 * Returns true if the user can access the given page.
 * - superadmin: always true
 * - saved permissions array: check inclusion
 * - null permissions: fall back to role defaults
 */
export function hasPageAccess(user, pageName) {
  if (!user) return false;
  if (user.role === 'superadmin') return true;

  const p = user.permissions;
  if (p) {
    const parsed = typeof p === 'string' ? JSON.parse(p) : p;
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed.includes(pageName);
    }
  }

  // Fall back to role defaults
  return ROLE_DEFAULTS[user.role]?.includes(pageName) ?? false;
}
